import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import RequestFundModalUI from './RequestFundModalUI.js'

class RequestFundModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      submitted: false,
      // request amount
      requestAmount: '',
      requestAmountError: null,
      // dueDate
      dueDate: null,
      dueDateError: null,
    }
  }

  render() {
    return (
      <RequestFundModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // update mode
        updateMode={this.props.requestFundMode}
        // request amount
        requestAmount={this.state.requestAmount}
        onRequestAmountChange={(event) => {this.setState({requestAmount: event.target.value})}}
        requestAmountError={this.state.requestAmountError}
        setRequestAmountError={(error) => {this.setState({requestAmountError: error})}}
        // dueDate
        dueDate={this.state.dueDate}
        onDueDateChange={(selectedDateISO) => {
          this.setState({dueDate: selectedDateISO})
        }}
        dueDateError={this.state.dueDateError}
        setDueDateError={(error) => {this.setState({dueDateError: error})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/budgets/${this.props.budget.budgetId}/fundRequest`,
      this.onSubmitCallback, {
        requestAmountF: this.state.requestAmount,
        requestDueDate: this.state.dueDate,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'requestAmount':
          this.setState({requestAmountError: error.message})
          break;
        case 'dueDate':
          this.setState({dueDateError: error.message})
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null, requestAmount: '', dueDate: null })
      }, 2000)
      this.props.onRequestComplete(response.budget)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      requestAmount: '',
      requestAmountError: null,
      dueDate: null,
      dueDateError: null,
      submitted: false
    })
    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_request_fund',
      'c_request_amount',
      'c_required_by',
      'c_request',
      'c_cancel',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('bdg_fund_req', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(RequestFundModalSF)
